export default "__VITE_ASSET__ddb8a0d2__"